/* eslint-disable react/require-default-props */
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import useAppStore from '@/store/app.store';
import useConfigStore from '@/store/configStore';

import { appRoutes } from '@/config/appRoutes';
import { COMPANY_TYPE } from '@/constants/company-type';
import { ROLES } from '@/constants/roles';

type ProtectedRouteProps = PropsWithChildren<{
  requiredRole: ROLES[];
  requiredCompanyType?: COMPANY_TYPE;
}>;

export default function ProtectedRoute({ children, requiredRole, requiredCompanyType }: ProtectedRouteProps) {
  const environmentSettings = useConfigStore((state) => state.environmentSettings);
  const user = useAppStore((state) => state.user);
  if (!user) {
    return null;
  }

  if (!requiredRole.includes(user.role as ROLES)) {
    return <Navigate to={`${environmentSettings?.BASE_PATH ?? ''}${appRoutes.ERROR_403}`} />;
  }

  if (
    user.role !== ROLES.MOEVE_ADMIN &&
    requiredCompanyType &&
    user.company?.companyType.code !== requiredCompanyType
  ) {
    return <Navigate to={`${environmentSettings?.BASE_PATH ?? ''}${appRoutes.ERROR_403}`} />;
  }

  return children;
}
